/** Full-page export id per domain — POST body is only `{ range, timezone }`. */
export function analyticsExportFullPageId(domain) {
  if (!domain) return '';
  return `${domain}_full_page`;
}

export function isAnalyticsExportFullPage(domain, section) {
  return !!domain && section === analyticsExportFullPageId(domain);
}

/** @deprecated use `analyticsExportFullPageId('overview')` */
export const OVERVIEW_FULL_PAGE_EXPORT_ID = analyticsExportFullPageId('overview');

/** Analytics CSV export: domain → API path + section ids (POST body `section`). */
export const DOMAIN_DEFINITIONS = {
  overview: {
    label: 'Overview',
    sections: ['overview_kpis', 'overview_all_stats', 'overview_heatmap'],
  },
  chat: {
    label: 'Chats',
    sections: [
      'chat_summary',
      'chat_performance',
      'chat_tag_usage',
      'chat_csat',
      'agent_response_time',
      'chat_accepting_status',
    ],
  },
  ticket: {
    label: 'Tickets',
    sections: [
      'ticket_summary',
      'ticket_performance',
      'ticket_tag_usage',
      'ticket_source',
    ],
  },
  agent: {
    label: 'Agents',
    sections: [
      'agent_summary',
      'agent_chat_stats',
      'agent_ticket_stats',
      'agent_csat',
      'agent_availability',
    ],
  },
  kb: {
    label: 'Knowledge Base',
    sections: [
      'kb_summary',
      'kb_top_search_terms',
      'kb_tag_performance',
      'kb_article_performance',
    ],
  },
};

export const ANALYTICS_EXPORT_DOMAIN_DEFINITIONS = DOMAIN_DEFINITIONS;

const FULL_PAGE_LABEL = 'All Sections';

const SECTION_LABELS = {
  overview_kpis: 'Overview KPI cards',
  overview_all_stats: 'All stats & bar chart',
  overview_heatmap: 'Heatmaps',
  chat_summary: 'Chat summary',
  chat_performance: 'Chats handled vs missed',
  chat_tag_usage: 'Tag usage',
  chat_csat: 'CSAT score',
  agent_response_time: 'First response time',
  chat_accepting_status: 'Chat accepting status',
  ticket_summary: 'Ticket summary',
  ticket_performance: 'New vs solved tickets',
  ticket_tag_usage: 'Tag usage',
  ticket_source: 'Ticket source',
  agent_summary: 'Agent summary',
  agent_chat_stats: 'Agent chat stats',
  agent_ticket_stats: 'Agent ticket stats',
  agent_csat: 'Agent CSAT',
  agent_availability: 'Agent availability',
  kb_summary: 'KB summary',
  kb_top_search_terms: 'Top search terms',
  kb_tag_performance: 'Tag performance',
  kb_article_performance: 'Article performance',
};

/**
 * @param {'overview'|'chat'|'ticket'|'agent'|'kb'} domain
 * @returns {{ value: string, label: string }[]}
 */
export function getAnalyticsExportSectionOptions(domain) {
  const def = DOMAIN_DEFINITIONS[domain];
  if (!def?.sections?.length) return [];
  const sectionRows = def.sections.map((section) => ({
    value: section,
    label: SECTION_LABELS[section] || section,
  }));
  return [
    {
      value: analyticsExportFullPageId(domain),
      label: FULL_PAGE_LABEL,
    },
    ...sectionRows,
  ];
}
